const template = require('./search.html');
require('./search.scss');
var logger = require('../../common/logging.config');

class SearchController {

	constructor($state, $q, $translate, $timeout, authSearchService, SearchTransformerService) {
		this.$state = $state;
		this.$q = $q;
		this.$translate = $translate;
		this.searchService = authSearchService;
		this.SearchTransformerService = SearchTransformerService;
        this.customSearchPerformed = false;
		
		this.searchRequest = SearchTransformerService.SearchRequest();

		// a11y hack - remove aria-expanded now that search input has role searchbox
		$timeout(() => {
			const searchInput = angular.element(document.querySelector('#search-input'));
			searchInput.removeAttr('aria-expanded');
		});
	}

	// user has submitted a search query with input text
	doFulltextSearch(query) {
		logger.info("SearchController doFulltextSearch entry");
		if (query.trim() === "") {
			return;
        }
        logger.info("Navigating to All Content and Assets with query: " + query);
        this.$state.go('authoring.content.all-content-and-assets', { searchParameter: {"q": query}});
	}
    
    clearSearch() {
        this.query = "";
        this.customSearchPerformed = false;
    }

    // user has typed some characters into text field so look for content item matches
    getTypeahead(userInput) {
        logger.info("getTypeahead - " + userInput);
        this.customSearchPerformed = true;
        // don't bother unless 2 characters have been entered
        if (userInput && userInput.trim().length >= 2) {
            return this.searchService.getTypeaheadSearchResults(this.searchRequest.getTypeaheadSearchString(userInput)).then(
    				(data) => {
    	                logger.info("Got typeahead search result - " + data);
    	                
    	                const result = this.SearchTransformerService.SearchResult(data);
    	                const facets = result.getFacets();
                        if (!this.interruptTypeahead) {
                        	var typeaheads = this.SearchTransformerService.transformFacetsIntoTypeahead(facets);
                        	// translate key to NLS field label here
                        	typeaheads.forEach(typeahead => {
                        		this.$translate(typeahead.fieldLabel).then(translation => {
                            		typeahead.fieldLabel = translation;
                        		});
                        	});
                            return typeaheads;
                        } else {
                            return [];
                        }
    				},
    				(error) => {
    					logger.error('Error retrieving typeahead search results data from server: ' + JSON.stringify(error));
    	                return [];
    				}
    		);
        }
        else {
            return this.$q(function(resolve) {
    			resolve([]);
    		});
        }
    }

    // user selected one of the typeahead items shown
    onSearchTypeaheadSelect($item) {
        logger.info("onSearchTypeaheadSelect - " + $item.getField() + ", " + $item.getValue() + ", " + $item.getFieldLabel() + ", " + $item.getValueLabel());

        // create a SearchFilter and send to authoring page
        const filter = this.SearchTransformerService.SearchFilter($item.getField(), $item.getValue(), $item.getFieldLabel(), $item.getValueLabel());
        this.$state.go('authoring.content.all-content-and-assets', { searchParameter: {"filters": [filter]}});
    	
    }
    
	/**
	 * Callback method when keyup event is triggered on input field
	 * Note: Keypress can't be used for ESC key, keydown doesn't work for firefox
	 * @param event
	 */
	keyup(event) {
		logger.info("keyup: " + event.which);
        if (event.which === 13) {
            this.interruptTypeahead = true;
			this.doFulltextSearch(this.query);
        } else if (event.which === 27) {
			this.clearSearch();
        } else {
            this.interruptTypeahead = false;
        }
	}
    
};

module.exports = {
	templateUrl: template,
	controller: ['$state', '$q', '$translate', '$timeout', 'authSearchService', 'SearchTransformerService', SearchController ]
};



// WEBPACK FOOTER //
// ./app/components/search/search.component.js